import { TDishFullInfoVisibleForm } from './dishFullInfoContext';
import { IItemDishesForGetInfo } from 'types';

export enum DishFullInfoActionTypes {
	SET_DISH_FOR_FULL_INFO = 'SET_DISH_FOR_FULL_INFO',
	CHANGE_DISH_FULL_INFO_VISIBLE_FORM = 'CHANGE_DISH_FULL_INFO_VISIBLE_FORM',
}

interface IChangeDishFullInfoVisibleForm {
	type: DishFullInfoActionTypes.CHANGE_DISH_FULL_INFO_VISIBLE_FORM;
	payload: {
		visibleForm: TDishFullInfoVisibleForm;
	};
}

interface ISetDishForFullInfo {
	type: DishFullInfoActionTypes.SET_DISH_FOR_FULL_INFO;
	payload: {
		dish: IItemDishesForGetInfo | null;
	};
}

export type TDishFullInfoAction = IChangeDishFullInfoVisibleForm | ISetDishForFullInfo;
